import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LosService } from "../../_LOS/services/los.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { constantUrl } from "../../Shared/constantUrl";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { DialogService } from "../../Shared/dialog.service";
import { LegalService } from "../services/Legal.service";
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
declare var $: any;

@Component({
    selector: "app-legal-cases-list",
    templateUrl: "./legal-cases-list.component.html",
    styleUrls: ["./legal-cases-list.component.scss"],
    standalone: false
})
export class LegalCasesListComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;

  dataSource: any;
  displayedColumns: string[] = [];
  JsonData: any[] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  Status: any = "";

  constructor(
    private dataSharingService: DataSharingService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private _EncrDecrService: EncrDecrService,
    private router: Router,
    private losService: LosService,
    private _LegalService: LegalService,
    private dialog: DialogService,
    private commonFunctions: CommonFunctions
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Legal Assign");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    // this.GetLegalCasesList();
  }

  GetLegalCasesList() {
    if (this.Status == "Pending") {
      this.displayedColumns = [
        "LegalId",
        "Created_On",
        "Notice_Type",
        "LoanAcNo",
        "Loan_Date",
        "Branch_Name",
        "Product_Name",
        "CustomerName",
        "DPD_Days",
        "Total_OverDUE_EMI__Amount",
        "Action",
      ];
    } else if (this.Status == "Legal") {
      this.displayedColumns = [
        "LegalId",
        "Case_Filed_By",
        "Date_Of_Case_Filing",
        "LoanAcNo",
        "Loan_Date",
        "Branch_Name",
        "Product_Name",
        "CustomerName",
        "DPD_Days",
        "Total_OverDUE_EMI__Amount",
        "Action",
      ];
    } else {
      this.displayedColumns = [
        "LegalId",
        "Case_Filed_By",
        "Date_Of_Case_Filing",
        "LoanAcNo",
        "Loan_Date",
        "Branch_Name",
        "Product_Name",
        "CustomerName",
        "DPD_Days",
        "Total_OverDUE_EMI__Amount",
        "StatusDate",
      ];
    }
    this.showSpinner = true;
    this._LegalService
      .Legal_Get_LegalCasesList({
        LoginUserId: this.currentUser.userId,
        Status: this.Status,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.JsonData = JSON.parse(JSON.stringify(res));
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        this.showSpinner = false;
      });
  }

  GetData(data) {
    if (data == true) {
      this.GetLegalCasesList();
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  GoToDetails(row) {
    let LegalId = this._EncrDecrService.encrypt(
      encodeURIComponent(row.LegalId)
    );
    let LoanId = this._EncrDecrService.encrypt(encodeURIComponent(row.Loan_Id));
    this.router.navigate([
      `lms-dashboard/legalcases/details/${LegalId}/${LoanId}`,
    ]);
  }

  exportTable(): void {
    const worksheetName = "LEGAL CASE LIST";
    this.commonFunctions.exportHtmlTableToExcel(
      "legal_cases_list",
      `${worksheetName}.xls`,
      worksheetName
    );
  }
}
